import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
}
const superagentApi = new SuperagentApi({
  baseUrl: window.ApiBase || 'http://pr.code.wiz.top:1052',
})
export default class DiyService {
  // 获取列表数据
  static async getTableData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/getTableData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 获取表单数据
  static async getFormData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/getFormData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 新增表单数据
  static async addFormData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/addFormData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 更新表单数据
  static async updateFormData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/uptFormData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 删除表单数据
  static async deleteFormData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/delFormData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 获取节点审批人
  static async getNodeConfirmUsers(payload) {
    const [err, res] = await superagentApi.post('/api/WorkFlow/GetNodeConfirmUsers', {
      data: payload,
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return [err, res]
  }
  // 获取下一节点审批人
  static async getNextNodeConfirmUsers(payload) {
    const [err, res] = await superagentApi.post('/api/WorkFlow/getNextNodeConfirmUsers', {
      data: payload,
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return [err, res]
  }

  // 获取考试计划列表
  static async getExamPlanList(payload) {
    const [err, res] = await superagentApi.get('/api/examination/get-plan-list', {
      params: payload,
      headers,
    })
    return [err, res]
  }
  // 接口引擎
  static async getInterfaceList(payload) {
    const [err, res] = await superagentApi.post('/api/ApiEngine/Run', {
      data: payload,
      headers: { ...headers, 'Content-Type': 'application/json' }
    })
    return [err, res]
  }
}
